<!--
 * @Author: chj
 * @Date: 2024-10-10 12:25:44
 * @LastEditors: chj
 * @LastEditTime: 2024-11-06 17:38:12
 * @Description: 导航
-->
<template>
  <nav :class="bem()">
    <div :class="bem('list')">
      <a-menu mode="horizontal" :selectedKeys="[selectedKey]">
        <!-- 渲染导航菜单项 -->
        <template v-for="route in filteredRoutes">
          <a-menu-item v-if="!route.children" :key="route.path">
            <router-link :class="bem('item')" :to="route.path">{{
              route.meta?.name
            }}</router-link>
          </a-menu-item>
          <a-sub-menu v-else :key="route.path">
            <template #title>
              <span :class="bem('sub')">{{ route.meta?.name }}</span>
            </template>
            <!-- 递归渲染子菜单 -->
            <a-menu-item
              v-for="child in route.children"
              :key="`${route.path}/${child.path}`"
            >
              <router-link
                :class="bem('item')"
                :to="`${route.path}/${child.path}`"
                >{{ child.meta?.name }}</router-link
              >
            </a-menu-item>
          </a-sub-menu>
        </template>
      </a-menu>
    </div>
    <a-dropdown v-if="token" :trigger="['click']" @click.native="close">
      <div :class="bem('user')">
        <a-avatar
          v-if="avatar"
          :class="bem('user-icon')"
          :src="avatar"
          :size="32"
          icon="user"
        />
        <a-avatar v-else :class="bem('user-icon')" :size="32" icon="user" />
      </div>
      <a-menu slot="overlay">
        <a-menu-item :class="bem('user-menu')" @click="centerHandle">
          <div :class="bem('user-menu-item')">个人中心</div>
        </a-menu-item>
        <a-menu-item :class="bem('user-menu')" @click="logoutHandle">
          <div :class="bem('user-menu-item')">退出登录</div>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <a-icon
      :class="bem('menu')"
      :type="drawerVisible ? 'close' : 'menu'"
      @click="drawerVisibleSwitch"
    />
    <div :class="bem('box')" v-if="drawerVisible">
      <div :class="bem('box-header')"></div>
      <div :class="bem('box-content')">
        <div :class="bem('box-list')">
          <a-menu mode="inline" :selectedKeys="[selectedKey]">
            <!-- 渲染导航菜单项 -->
            <template v-for="route in filteredRoutes">
              <a-menu-item v-if="!route.children" :key="route.path">
                <router-link :class="bem('item')" :to="route.path">{{
                  route.meta?.name
                }}</router-link>
              </a-menu-item>
              <a-sub-menu v-else :key="route.path">
                <template #title>
                  <span :class="bem('sub')">{{ route.meta?.name }}</span>
                </template>
                <!-- 递归渲染子菜单 -->
                <a-menu-item
                  v-for="child in route.children"
                  :key="`${route.path}/${child.path}`"
                >
                  <router-link
                    :class="bem('item')"
                    :to="`${route.path}/${child.path}`"
                    >{{ child.meta?.name }}</router-link
                  >
                </a-menu-item>
              </a-sub-menu>
            </template>
          </a-menu>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import {
  Icon as AIcon,
  Menu as AMenu,
  Dropdown as ADropdown,
  Avatar as AAvatar,
} from "ant-design-vue";
import { mapGetters } from "vuex";
export default {
  name: "app-nav",
  components: {
    AIcon,
    AAvatar,
    ADropdown,
    AMenu,
    AMenuItem: AMenu.Item,
    AMenuItemGroup: AMenu.ItemGroup,
    ASubMenu: AMenu.SubMenu,
  },
  data() {
    return {
      menuCurrent: [],
      selectedKey: this.$route.path,
      drawerVisible: false,
    };
  },
  watch: {
    "$route.path"(path) {
      this.selectedKey = path;
    },
  },
  computed: {
    ...mapGetters(["token", "avatar", "navRouters"]),
    filteredRoutes() {
      if (this.token) {
        return this.navRouters.filter(
          (route) =>
            route.meta && route.meta.nav != false && route.name != "account"
        );
      }
      return this.navRouters.filter(
        (route) => route.meta && route.meta.nav != false
      );
    },
  },
  methods: {
    close() {
      this.drawerVisible = false;
    },
    drawerVisibleSwitch() {
      this.drawerVisible = !this.drawerVisible;
    },
    centerHandle() {
      this.$router.push({ path: "/center" });
    },
    logoutHandle() {
      this.$store.dispatch("LogOut").then(() => {
        window.location.href = "/";
      });
    },
    onWindowResize() {
      if (this.drawerVisible) {
        this.drawerVisible = false;
      }
    },
  },
  mounted() {
    window.addEventListener("resize", this.onWindowResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onWindowResize);
  },
};
</script>

<style lang="scss" scoped>
.app-nav {
  display: flex;
  align-items: center;
  height: 100%;
  &__list {
    display: flex;
    align-items: center;
    height: 100%;
    @include devices(pad) {
      display: none;
    }
    @include devices(phone) {
      display: none;
    }
  }
  &__item {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 15px;
    height: 100%;
    color: #1a1a1a;
    text-align: center;
    padding: 0 16px;
    text-decoration: none;
    &:hover {
      cursor: pointer;
      color: #ff6900;
      font-weight: 500;
    }
  }
  &__sub {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 15px;
    height: 100%;
    text-align: center;
    padding: 0 16px;
    text-decoration: none;
    &:hover {
      cursor: pointer;
      color: #ff6900;
      font-weight: 500;
    }
  }
  &__menu {
    display: none;
    cursor: pointer;
    font-size: 32px;
    @include devices(pad) {
      display: block;
    }
    @include devices(phone) {
      font-size: 26px;
      display: block;
    }
  }
  &__box {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    transition: height 0.3s ease-in-out, opacity 0.4s ease-in-out 0.1s;
    pointer-events: none;
    &-header {
      flex-shrink: 0;
      height: 80px;
      @include devices(phone) {
        height: 68px;
      }
    }
    &-content {
      flex: 1;
      // background-color: rgba(0, 0, 0, .5);
    }
    &-list {
      pointer-events: auto;
      width: 100%;
      display: flex;
      flex-direction: column;
      background-color: #ffffff;
    }
    &-item {
      padding-left: 16px;
      height: 57px;
      display: flex;
      align-items: center;
      font-size: 18px;
      border-bottom: 1px solid rgba(11, 38, 64, 0.08);
      cursor: pointer;
    }
  }
  &__user {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    font-weight: 400;
    font-size: 14px;
    height: 100%;
    color: #1a1a1a;
    text-align: center;
    padding: 0 16px;
    text-decoration: none;
    &:hover {
      cursor: pointer;
      color: #ff6900;
      font-weight: 500;
    }
    &-icon {
      width: 32px;
      height: 32px;
    }
    &-menu {
      &-item {
        display: flex;
        align-items: center;
        height: 40px;
        padding: 0 20px;
      }
    }
  }
  :deep(.ant-menu-horizontal) {
    border-bottom: none;
  }
  :deep(.ant-menu-submenu-title) {
    padding: 0;
  }
  :deep(.ant-menu) {
    border-bottom: none;
  }
  :deep(.ant-menu-item) {
    padding: 0;
  }
  :deep(.ant-menu-item) {
    border-bottom: none;
  }
  :deep(.ant-menu-submenu) {
    border-bottom: none;
  }
  :deep(.ant-menu-submenu-selected) {
    border-bottom: none;
  }
}
</style>
